interface ICollectionAccountAccessDenied {
  description?: string;
  title?: string;
}

const CollectionAccountAccessDenied = ({
  description = 'You currently do not have permission to access this section.',
  title = 'Access Denied',
}: ICollectionAccountAccessDenied) => {
  return (
    <div className="flex flex-col justify-center gap-2 self-stretch">
      <div className="flex flex-col justify-center gap-5 py-8">
        <div className="flex flex-col items-center justify-center gap-8">
          <h3 className="text-sr-black">{title}</h3>

          <span className="items-center text-base font-normal text-sr-black">
            {description}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CollectionAccountAccessDenied;
